import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";
import { toast } from "react-toastify";

const usePurchaseUsdt = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const UsdtAdress = Environment.busd;
  const tokenAddress = Environment.presaleContract;
  const contract = chinaContract(tokenAddress, web3);

  const purchaseUsdt = useCallback(
    async (
      amount,
      postApiRes,
      id,
      balance,
      min,
      stakeIndex,
      index,
      insurancePer
    ) => {
      if (!account) {
        // toast.error("Please connect wallet");
        return null;
      }

      try {
        /* ------------------ Calculate USDT amount ------------------ */
        let nd = "0";

        if (index) {
          const percent = parseFloat(amount) * insurancePer;
          const value = parseFloat(amount) + percent;
          const fixed =
            Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
          nd = web3.utils.toWei(fixed.toString(), "mwei");
        } else {
          const fixed =
            Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
          nd = web3.utils.toWei(fixed.toString(), "mwei");
        }

        /* ------------------ Min value ------------------ */
        let minValue = min * 0.99;
        minValue =
          Math.round(parseFloat(minValue).toFixed(6) * 1e12) / 1e12;
        minValue = web3.utils.toWei(minValue.toString(), "ether");


        /* ------------------ Send TX (EVENT BASED) ------------------ */
        return new Promise((resolve, reject) => {
          contract.methods
            .purchaseTokenWithToken(
              UsdtAdress,
              postApiRes?.normalizationFactor,
              postApiRes?.normalizationFactorNft,
              postApiRes?.price,
              nd,
              minValue,
              stakeIndex,
              postApiRes?.agentsAddresses,
              postApiRes?.agentsPercentages,
              postApiRes.code,
              id,
              postApiRes.deadline,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s
            )
            .send({ from: account })

            /* ✅ INSTANT RESOLVE (mobile safe) */
            .on("transactionHash", (hash) => {


              // resolve({
              //   transactionHash: hash,
              // });
            })

            /* ✅ CONFIRMED */
            .on("receipt", (receipt) => {
              console.log("Transaction confirmed:", receipt);
              resolve({
                transactionHash: receipt?.transactionHash,
              });
            })

            /* ❌ ERROR */
            .on("error", (error) => {
              console.error("Transaction error:", error);

              reject(error);
            });
        });
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    [account, contract, web3]
  );

  return { purchaseUsdt };
};

export default usePurchaseUsdt;
// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { chinaContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";
// import { toast } from "react-toastify";

// const PurchaseUsdt = () => {
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const UsdtAdress = Environment.busd;
//   const priceUsdt = 10000;
//   const tokenAddress = Environment.presaleContract;
//   const contract = chinaContract(tokenAddress, web3);
//   const purchaseUsdt = useCallback(
//     async (
//       amount,
//       postApiRes,
//       id,
//       balance,
//       min,
//       stakeIndex,
//       index,
//       insurancePer
//     ) => {
//       let nd = 0;
//       if (index) {
//         let percecnt = parseFloat(amount) * insurancePer;
//         let value = parseFloat(amount) + percecnt;
//         let valuess = parseFloat(value).toFixed(6);
//         let amount1 = Math.round(valuess * 1e12) / 1e12;
//         nd = web3.utils.toWei(amount1.toString(), "mwei");
//       } else {
//         let valuess = parseFloat(amount).toFixed(6);
//         let amount1 = Math.round(valuess * 1e12) / 1e12;
//         nd = web3.utils.toWei(amount1.toString(), "mwei");
//       }

//       let minvalue = min * 0.99;
//       minvalue = parseFloat(minvalue).toFixed(6);
//       minvalue = Math.round(minvalue * 1e12) / 1e12;
//       // console.log(minvalue,'minvalue');
//       minvalue = web3.utils.toWei(minvalue.toString(), "ether");

//       // console.log(UsdtAdress,postApiRes?.normalizationFactor,postApiRes?.price, nd,minvalue,stakeIndex,postApiRes.code,id,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s,index,' nd,postApiRes.code,id,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s');
//       //     let tuple = {
//       //       postApiRes.code:postApiRes.postApiRes.code,
//       //       GodAgentPercentage:postApiRes.gotAgentPercentage,
//       //       MegaAgentPercentage:postApiRes.megaAgentPercentage,
//       //       SuperAgentPercentage:postApiRes.superAgentPercentage,
//       //       AgentPercentage:postApiRes.agentPercentage,
//       //       GodAgentAddress:postApiRes.gotAgentAddress,
//       //       MegaAgentAddress:postApiRes.megaAgentAddress,
//       //       SuperAgentAddress:postApiRes.superAgentAddress,
//       //       AgentAddress:postApiRes.agentAddress,
//       // };
//       console.log(
//         UsdtAdress,
//         postApiRes?.normalizationFactor,
//         postApiRes?.price,
//         nd,
//         minvalue,
//         stakeIndex,
//         postApiRes?.agentsAddresses,
//         postApiRes?.agentsPercentages,
//         postApiRes.code,
//         id,
//         postApiRes.deadline,
//         postApiRes?.v,
//         postApiRes?.r,
//         postApiRes?.s,
//         index
//       );
//       let gas;
//       try {
//         // let gasPrice = await web3.eth.getGasPrice();
//         // gasPrice = parseInt(gasPrice) + 3000000000;
//         // gas = await contract.methods
//         //   .purchaseTokenWithToken(
//         //     UsdtAdress,
//         //     postApiRes?.price,
//         //     postApiRes?.normalizationFactor,
//         //     postApiRes?.normalizationFactorNft,
//         //     nd,
//         //     minvalue,
//         //     stakeIndex,
//         //     postApiRes?.agentsAddresses,
//         //     postApiRes?.agentsPercentages,
//         //     // index,
//         //     postApiRes.code,
//         //     id,
//         //     postApiRes.deadline,
//         //     postApiRes?.v,
//         //     postApiRes?.r,
//         //     postApiRes?.s
//         //   )
//         //   .estimateGas({
//         //     from: account,
//         //     gasPrice,
//         //   });
//         const details = await contract.methods
//           .purchaseTokenWithToken(
//             UsdtAdress,
//             postApiRes?.normalizationFactor,
//             postApiRes?.normalizationFactorNft,
//             postApiRes?.price,
//             nd,
//             minvalue,
//             stakeIndex,
//             postApiRes?.agentsAddresses,
//             postApiRes?.agentsPercentages,
//             // index,
//             postApiRes.code,
//             id,
//             postApiRes.deadline,
//             postApiRes?.v,
//             postApiRes?.r,
//             postApiRes?.s
//           )
//           .send({
//             from: account,
//             // gas: gas,
//             // gasPrice,
//           });
//         return details;
//       } catch (error) {
//         // let gasPrice1=await web3.eth.getGasPrice()
//         // let gasPrice = parseInt(gasPrice1) + 3000000000
//         // gas=gas*gasPrice
//         // let nd = web3.utils.fromWei(gas.toString(), "ether");
//         // console.log(gas,nd,balance );
//         // if(nd>balance){
//         //    toast.error("Insufficient ETH for Transaction")
//         // }else{
//         throw error;
//         // }
//       }
//     },
//     [contract, account, web3]
//   );
//   return { purchaseUsdt: purchaseUsdt };
// };
// export default PurchaseUsdt;
